import { render, staticRenderFns } from "./TaxPayListCard.vue?vue&type=template&id=31ff1147&"
import script from "./TaxPayListCard.vue?vue&type=script&lang=js&"
export * from "./TaxPayListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports